export const DELETE_BOARD = 'events/DELETE_BOARD';

/**
 * @param board
 * @return {{type: string, payload: {board, intl, messages}}
 */
export const deleteBoard = (board, intl, messages) => ({
  type: DELETE_BOARD,
  payload: { board, intl, messages },
});
